import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DisplayContainer from "../../../../components/displayContainer/DisplayContainer";
import Loader from "../../../../components/loader/Loader";
import OneEmployee from "../../../../components/oneEmployee/OneEmployee";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import { fetchAdmins } from "../../../../features/admins/adminsSlice";
import styles from "./allEmployees.module.css";

const AllEmployess = () => {
  const dispatch = useDispatch();
  const {
    list: admins,
    fetchStatus,
    deleteStatus,
  } = useSelector((state) => state.admins);

  const { userId } = useSelector((state) => state.user);

  useEffect(() => {
    if (fetchStatus === "idle") {
      dispatch(fetchAdmins());
    }
  }, [dispatch, fetchStatus]);

  const visibleAdmins = admins.filter((admin) => admin._id !== userId);

  if (fetchStatus === "loading" || deleteStatus === "loading") {
    return (
      <div className={styles.loaderContainer}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.summaryCard}>
          <span className={styles.summaryValue}>{visibleAdmins.length} موظف</span>
        </div>
        <div className={styles.headingBlock}>
          <TextWrapper textStyle="textTitle">جميع الموظفين</TextWrapper>
        </div>
      </div>
      <div className={styles.allAdminsWrapper}>
        <DisplayContainer className={styles.employeePanel}>
          {visibleAdmins.length ? (
            visibleAdmins.map((admin) => (
              <OneEmployee
                name={admin.name}
                role={admin.role}
                addedTime={admin.createdAt}
                modifiedTime={admin.updatedAt}
                adminId={admin._id}
                key={admin._id}
              />
            ))
          ) : (
            <div className={styles.emptyState}>
              <div className={styles.emptyStateContent}>
                <h3 className={styles.emptyStateTitle}>
                  لا يوجد موظفون لعرضهم حالياً
                </h3>
                <p className={styles.emptyStateDescription}>
                  سيظهر أي موظف جديد هنا بمجرد إضافته إلى النظام ومنحه صلاحيات
                  العمل.
                </p>
              </div>
            </div>
          )}
        </DisplayContainer>
      </div>
    </div>
  );
};

export default AllEmployess;
